import React from "react";

import "./ContentsTwoColumn.css";

export default function Index({ data, firstColorRed }) {
  return (
    <section className="contents-two-column">
      <div className="container">
        {data.length > 0 ? (
          data.map((item, index) => {
            return (
              item.title &&
              item.text &&
              item.img && (
                <div
                  className={
                    index % 2 !== 0 ? "row even" : "row flex-row-reverse odd"
                  }
                >
                  <div
                    className={`col-lg-6 col-sm-12 ${
                      item.class ? item.class : null
                    }`}
                  >
                    <div className="text-wrapper">
                      <div className="table-cell">
                        {item.title && (
                          <div className="title">
                            <h2
                              className={
                                firstColorRed
                                  ? index % 2 !== 0
                                    ? "primary"
                                    : "accent"
                                  : index % 2 === 0
                                  ? "primary"
                                  : "accent"
                              }
                            >
                              {item.title}
                            </h2>
                          </div>
                        )}
                        {item.text && <p>{item.text}</p>}
                        {item.sub_text && <p>{item.sub_text}</p>}
                        {item.text_bold && (
                          <p className="text-bold">{item.text_bold}</p>
                        )}
                        {item.icon_contents ? (
                          <div className="icon-contents d-flex">
                            <item.icon_contents.icon />
                            <p>
                              <span className="stronger">
                                {item.icon_contents.title}
                              </span>
                              {item.icon_contents.text}
                            </p>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div
                    className={`col-lg-6 col-sm-12 ${
                      item.class ? item.class : null
                    }`}
                  >
                    {item.img && (
                      <div className="image-wrapper">
                        <img src={item.img} alt="softwareSolution" />
                      </div>
                    )}
                    {item.high_light_text ? (
                      <div className="high-light-texts">
                        <ul className="d-flex">
                          {item.high_light_text.map(highLight => (
                            <li>{highLight}</li>
                          ))}
                        </ul>
                      </div>
                    ) : null}
                  </div>
                </div>
              )
            );
          })
        ) : (
          <div className="row">
            <div
              className={`col-lg-6 col-sm-12 ${data.class ? data.class : null}`}
            >
              <div className="text-wrapper">
                <div className="title">
                  <h2 className="primary">{data.title}</h2>
                </div>
                {data.text
                  ? data.text.map(textItem => <p key={textItem}>{textItem}</p>)
                  : null}
              </div>
            </div>
            <div
              className={`col-lg-6 col-sm-12 ${data.class ? data.class : null}`}
            >
              <div className="image-wrapper">
                <img src={data.img} alt="softwareSolution" />
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
